
	/**
	 * @description
	 *  Modelo de un ítem en un pedido.
	 *
	 * @see gigot-backend/Models/Orders/Order.cs
	 */

export class OrderItem {

	;

	/**
	 * @description
	 *	Construye un ítem de pedido con una semántica vacía. Nótese que no es
	 *	lo mismo que construir una selección con valores por defecto. Las
	 *	reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un ítem vacío.
	 */
	public static empty(): OrderItem {
		const orderItem: OrderItem = new OrderItem();
		return orderItem;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderItem
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderItem: OrderItem): OrderItem {
		if (!anemicOrderItem) return undefined;
		const orderItem: OrderItem = OrderItem.empty();
		return orderItem;
	}
}
